// extracted by mini-css-extract-plugin
export default {"text":"styles_text__1nlc6","header":"styles_header__K2c2J","whiteText":"styles_whiteText__fPpLq"};